"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyDefaults = void 0;
exports.MoneyDefaults = {
    EUR: {
        pattern: "#\xa0€",
        negativePattern: "-#\xa0€",
    },
    USD: {
        pattern: "$#",
        negativePattern: "-$#",
    },
};
